<template>
  <div class="layout">
    <Header class="Header" />
    <div class="main-content">
      <Sidebar>
        <Navigation v-if="hasChildMenu" class="navigation" />
        <router-view class="router-view" />
      </Sidebar>
    </div>
    <Footer class="Footer" />
  </div>
</template>

<script>
import Header from "@/layout/Header.vue";
import Sidebar from "@/layout/Sidebar.vue";
import Navigation from "@/layout/Navigation.vue";
import Footer from "@/layout/Footer.vue";

export default {
  components: {
    Header,
    Sidebar,
    Navigation,
    Footer,
  },
  data() {
    return {
      screen: false,
    };
  },
  computed: {
    hasChildMenu() {
      const currentPath = this.$route.path;
      let navigationConfig = [
        "/equipmentmsg/equipmentmsgs",
        "/inoutlibrary/inoutlibrarys",
        "/userlist/userlists",
        "/detail/personal",
        "/basicsmsg/basicsmsgs",
      ];

      // 基础信息菜单只有当orgLevel=1时才显示
      try {
        const menuData = JSON.parse(localStorage.getItem("menuList"));
        if (menuData && menuData.orgLevel == 1) {
          navigationConfig.push("/basicsmsg/basicsmsgs");
        }
      } catch (error) {
        console.warn("获取menuList失败:", error);
      }

      return navigationConfig.includes(currentPath);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.layout {
  background-color: #f0f2f4;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  overflow: hidden;
}
</style>
